import type { TeamData, TeamsResponse } from '@library/types/teams';

export const transformTeamsData = (response: TeamsResponse | undefined) => {
  return response?.data.map(({ id, attributes }) => ({
    id,
    name: attributes.name,
    market: attributes.market,
    primaryColor: attributes.primary_color
      ? `#${attributes.primary_color}`
      : '',
    secondaryColor: attributes.secondary_color
      ? `#${attributes.secondary_color}`
      : '',
    tertiaryColor: attributes.tertiary_color
      ? `#${attributes.tertiary_color}`
      : '',
    ppid: attributes.ppid,
    newPlayers: attributes.new_players,
    homeGames: attributes.home_games,
    awayGames: attributes.away_games,
    league: attributes.league,
    abbreviation: attributes.abbreviation,
    type: attributes.type
  }));
};

export const mapTeamDataToRequest = (teamData: TeamData) => {
  return {
    name: teamData.name,
    market: teamData.market,
    primary_color: teamData.primaryColor,
    secondary_color: teamData.secondaryColor,
    tertiary_color: teamData.tertiaryColor,
    league_id: teamData.league,
    new_player_ids: teamData.newPlayers,
    home_game_ids: teamData.homeGames,
    away_game_ids: teamData.awayGames,
    abbreviation: teamData.abbreviation,
    type: teamData.type
  };
};

export const transformTeamOptions = (teams: Array<TeamData>) => {
  return teams.map((team) => ({
    name: team.name,
    value: team.id,
    key: team.id
  }));
};
